import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Cancel one of the party's pending invites (DELETE /queue/party-invites/{id}).
 *
 * Current-leader authorization is server-enforced. On settlement both
 * `party.detail(partyId)` (seat/roster view) and `party.sentInvites(partyId)`
 * (the "Invited (pending)" list) are invalidated so the cancelled invite drops.
 * Errors are NOT swallowed — a 409 (already responded) or 403 (not the
 * inviter/leader) surfaces on `mutation.error` for the page to map.
 */
export function useCancelPartyInvite(partyId: string) {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (inviteId: string) => queueApi.cancelPartyInvite(inviteId),
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.party.detail(partyId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.party.sentInvites(partyId),
        refetchType: "active",
      });
    },
  });
}
